module.exports = __webpack_public_path__ + "img/ACTIVITES_EXT_ACTIVE.63f13a8c.svg";